import chunk from 'lodash/chunk';
import { useEffect, useState } from 'react';
import { apiClient } from '../../../../../../../api';
import { useActiveStation } from '../../../../../../../core/stations/hooks/useActiveStation';
import { useStreamSegmentsRange } from '../../../hooks/segments/useStreamSegmentsQuery';

/**
 * Pre-fetches segment audio to populate browser HTTP cache.
 * The browser will automatically cache responses based on Cache-Control headers.
 */
export const useCacheSegmentsAudio = () => {
  const station = useActiveStation();
  const streamRange = useStreamSegmentsRange();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const getSegmentsAudio = async () => {
      try {
        const sequence = await apiClient.segments.fetchSequence(station.id, streamRange.from);

        const totalSegments = sequence.length;
        let segmentsDownloaded = 0;
        const chunkedSequence = chunk(sequence, 4);

        await chunkedSequence.reduce(async (previousPromise, chunk) => {
          await previousPromise;

          await Promise.all(
            chunk.map(async (segment) => {
              try {
                // Pre-fetch audio to populate browser HTTP cache
                await apiClient.segments.fetchSegmentAudio(station.id, segment.id);
              } catch (error) {
                console.error(`Error fetching audio for segment ${segment.id}:`, error);
              } finally {
                segmentsDownloaded++;
                const newProgress = Math.floor((segmentsDownloaded / totalSegments) * 100);
                setProgress(newProgress);
              }
            }),
          );

          await new Promise((resolve) => setTimeout(resolve, 4));
        }, Promise.resolve());
      } catch (error) {
        console.error('Error fetching segment sequence:', error);
      }
    };

    getSegmentsAudio();
  }, [station.id, streamRange]);

  return {
    progress,
  };
};
